module.exports = __webpack_public_path__ + "assets/img/seal-3ba5e21a.png";